import { render, staticRenderFns } from "./dashboardparc.vue?vue&type=template&id=85767a38"
import script from "./dashboardparc.vue?vue&type=script&lang=js"
export * from "./dashboardparc.vue?vue&type=script&lang=js"
import style0 from "./dashboardparc.vue?vue&type=style&index=0&id=85767a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports